export default __webpack_public_path__ + "static/media/21.099842bd.jpg";